<onyx-section [heading]="`${I18N}.heading`">
  <form [formGroup]="form()">
    @let controls = form().controls;
    <onyx-dropdown
      data-testid="emission-standard-dropdown"
      [formControl]="controls.emissionStandard"
      label="labels.emissionStandard"
      [options]="emissionStandards$ | async"
      [size]="32"
    ></onyx-dropdown>

    <onyx-upload
      data-testid="emission-certificate-upload"
      [formControl]="controls.emissionCertificate"
      label="labels.emissionCertificate"
      [size]="32"
    ></onyx-upload>
  </form>
</onyx-section>
